<template lang="pug">
    Modal(v-model="isModalOpened" :title="$t('global.reminderText')" width="600"  @on-cancel="$emit('closeSourceNatModal')" transfer  :mask-closable="false" :closable="false")
            p {{$t("slbsetting.toggleOffSourceNatText")}}
            List(:split="false")
                    ListItem {{$t("slbsetting.toggleOffSourceNatLiOne")}}
                    ListItem {{$t("slbsetting.toggleOffSourceNatLiTwo")}}
                    ListItem {{$t("slbsetting.toggleOffSourceNatLiThree")}}
            CopyText(style="float: right; padding: 10px" :text="command")
            p(style="white-space: pre-line; marginBottom: 10px; background: #EEE; padding: 10px") {{ command }}
            Checkbox(v-model="check") {{$t("slbsetting.toggleOffSourceNatCheckbox")}}
            div(slot="footer")
                    Button(type="primary" @click="closeSourceNatModal()") {{$t('rcmtable.confirmText')}}
</template>

<script>
import CopyText from "@/components/CopyText";

export default {
    props: {
        isSourceNatModalShown: { type: Boolean, default: false },
    },
    components: { CopyText: CopyText },
    data() {
        return {
            isModalOpened: false,
            command:
                "#!/bin/bash\n" +
                "/sbin/iptables -F\n" +
                "/sbin/iptables -t mangle -N DIVERT\n" +
                "/sbin/iptables -t mangle -A PREROUTING -p tcp -m socket -j DIVERT\n" +
                "/sbin/iptables -t mangle -A DIVERT -j MARK --set-mark 1\n" +
                "/sbin/iptables -t mangle -A DIVERT -j ACCEPT\n" +
                "/sbin/ip rule add fwmark 1 lookup 100\n" +
                "/sbin/ip route add local 0.0.0.0/0 dev lo table 100",
            check: false,
        };
    },
    watch: {
        isSourceNatModalShown: {
            deep: true,
            immediate: true,
            handler: function (val) {
                this.isModalOpened = val;
            },
        },
    },
    methods: {
        closeSourceNatModal() {
            if (!this.check) {
                return this.$Message.warning(this.$t("slbsetting.checkToContinue"));
            }

            this.isModalOpened = false;
            this.check = false;
            this.$emit("closeSourceNatModal", this.isModalOpened);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/SourceNatModal.vue